var SAPI_DEBUGGING = false;

function sapiLog(message) {
  if (SAPI_DEBUGGING) {
    console.log("[SAPI]", message);
  }
}

sapiLog("Watching sale price change...");
document.addEventListener("DOMContentLoaded", function () {
  const SALE_PRICE_SELECTOR = "span[data-spresso-item-id]";
  const targetNodes = document.querySelectorAll(SALE_PRICE_SELECTOR);

  if (targetNodes.length === 0) return; // Exit if no target nodes are found

  targetNodes.forEach((targetNode) => {
    // Set up the observer configuration
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "childList" &&
          targetNode.innerHTML.trim() !== ""
        ) {
          const productId = targetNode.getAttribute("data-spresso-item-id");
          const salePrice = extractPriceNumber(targetNode.textContent);
          
          handleSalePriceDisplayed(productId, salePrice);

          observer.disconnect(); // Stop observing this node once content is added
        }
      }
    };

    // Create an observer instance for this targetNode
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  });
});

function handleSalePriceDisplayed(productId, salePrice) {
  sapiLog(">> Loaded price from Spresso!", productId, salePrice);
  const discountPercentDOMs = document.querySelectorAll(
    `.product-card__discount[data-product-id="${productId}"]`
  );
  discountPercentDOMs.forEach((discountPercentDOM) =>
    updateDiscountPercent(discountPercentDOM, productId, salePrice)
  );

  const pricePerOneDOMs = document.querySelectorAll(
    `.c-per-price__one-sale[data-product-id="${productId}"]`
  );
  pricePerOneDOMs.forEach((pricePerOneDOM) =>
    updatePricePerOne(pricePerOneDOM, productId, salePrice)
  );
}

function updateDiscountPercent(discountPercentDOM, productId, salePrice) {
  sapiLog("updateDiscountPercent", discountPercentDOM);

  const priceText = discountPercentDOM.getAttribute("data-product-price");
  const price = Number(priceText) / 100;
  sapiLog({ price });
  if (!price) return;

  const hasDiscount = salePrice < price;
  sapiLog({ hasDiscount });
  if (!hasDiscount) return;

  const discountAmount = price - salePrice;
  const discountPercent = Math.round((discountAmount * 100) / price);

  // Update UI: ProductCard
  discountPercentDOM.querySelector(
    `.product-card__discount-percent`
  ).textContent = discountPercent;
  discountPercentDOM.style.display = "block";
  // Update UI: ProductGalleryMedia
  const productGalleryMedias = document.querySelectorAll(
    ".product-gallery__media"
  );
  productGalleryMedias.forEach(
    (dom) => dom && dom.classList.add("product-gallery__media_with_discount")
  );
}

function updatePricePerOne(pricePerOneDOM, productId, salePrice) {
  sapiLog("updatePricePerOne", pricePerOneDOM);

  const priceText = pricePerOneDOM.getAttribute("data-product-price");
  const price = Number(priceText) / 100;
  sapiLog("price", price);
  if (!price) {
    return;
  }

  const pricePerOneWithCurrency = pricePerOneDOM.getAttribute(
    "data-product-price_per_one_with_currency"
  );
  const pricePerOne = extractPriceNumber(pricePerOneWithCurrency);
  sapiLog("pricePerOne", pricePerOne);
  if (!pricePerOne) {
    return;
  }

  let packagingQuantity = price / pricePerOne;
  sapiLog("packagingQuantity", packagingQuantity);
  if (!packagingQuantity) {
    return;
  }

  sapiLog({
    price,
    packagingQuantity,
    pricePerOne,
  });

  const newPricePerOne = Math.round(salePrice / packagingQuantity);
  sapiLog("newPricePerOne", newPricePerOne);

  if (isNaN(newPricePerOne)) {
    const SPACE = '\u00A0';
    pricePerOneDOM.textContent = `1本あたり¥${SPACE} ${SPACE} 税込`;
  } else {
    pricePerOneDOM.textContent = `¥${newPricePerOne} 税込 / 1本あたり`;
  }
}

// Helper function
function extractPriceNumber(priceText) {
  const priceValue = priceText.replace(/[^\d]/g, ""); // Remove non-numeric characters
  return parseInt(priceValue);
}
